import { Link } from "react-router-dom";
import { useScrollAnimation } from "@/hooks/useScrollAnimation";

export default function ServiceSection() {
  const { ref: textRef, isVisible: textVisible } = useScrollAnimation({ threshold: 0.15 });
  const { ref: imgRef, isVisible: imgVisible } = useScrollAnimation({ threshold: 0.15 });

  return (
    <section id="service" className="py-0 bg-[#f0fafb]">
      {/* レイアウト反転：テキスト左・画像右 */}
      <div className="flex flex-col lg:flex-row-reverse items-stretch min-h-[480px]">
        {/* Image — right side */}
        <div
          className="w-full lg:w-1/2 h-72 lg:h-auto overflow-hidden"
          ref={imgRef as React.RefObject<HTMLDivElement>}
          style={{
            opacity: imgVisible ? 1 : 0,
            transform: imgVisible ? "translateX(0)" : "translateX(40px)",
            transition: "opacity 1s ease, transform 1s ease",
          }}
        >
          <img
            src="https://static.readdy.ai/image/e643b173cc54a8b3f926f18f1e409a57/4ecba124a94f5a773c6cd1be9f1938ec.jpeg"
            alt="ヘルパーステーションみりん 訪問介護サービス"
            className="w-full h-full object-cover object-top hover:scale-105 transition-transform duration-700"
          />
        </div>

        {/* Text — left side */}
        <div
          className="w-full lg:w-1/2 bg-[#3ab5c6] flex items-center px-10 md:px-16 py-14"
          ref={textRef as React.RefObject<HTMLDivElement>}
        >
          <div>
            <p
              className="text-white/70 text-xs font-['Poppins'] tracking-widest mb-3"
              style={{
                opacity: textVisible ? 1 : 0,
                transform: textVisible ? "translateY(0)" : "translateY(20px)",
                transition: "opacity 0.7s ease 0.2s, transform 0.7s ease 0.2s",
              }}
            >
              FD SERVICE
            </p>
            <h2
              className="text-2xl md:text-3xl font-bold text-white leading-snug mb-6"
              style={{
                opacity: textVisible ? 1 : 0,
                transform: textVisible ? "translateY(0)" : "translateY(20px)",
                transition: "opacity 0.7s ease 0.35s, transform 0.7s ease 0.35s",
              }}
            >
              ヘルパーステーション<br />みりんのサービス
            </h2>
            <p
              className="text-white/90 text-sm leading-relaxed mb-4"
              style={{
                opacity: textVisible ? 1 : 0,
                transform: textVisible ? "translateY(0)" : "translateY(20px)",
                transition: "opacity 0.7s ease 0.5s, transform 0.7s ease 0.5s",
              }}
            >
              ケアマネジャー・相談支援専門員などと連携をとりながら、ご本人・ご家族の不安を少しでも取り除き、安心してご自宅で介護・生活支援を受けられるようサポートします。訪問介護・障害福祉サービスを通じて、幅広いニーズに応じた最適なサービスをご提供します。
            </p>
            <Link
              to="/service"
              className="inline-flex items-center gap-2 border border-white text-white text-sm px-6 py-2.5 rounded-full hover:bg-white hover:text-[#3ab5c6] transition-colors cursor-pointer whitespace-nowrap"
              style={{
                opacity: textVisible ? 1 : 0,
                transform: textVisible ? "translateY(0)" : "translateY(20px)",
                transition: "opacity 0.7s ease 0.75s, transform 0.7s ease 0.75s",
              }}
            >
              <span>›</span> サービスの詳細へ
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
